<template>
	<div class="lab_bottomRight">
		<!--<div class="lab_bottomTitle">
			<img src="@/images/lab_titleBack.png" class="lab_titleBack" />
			<span>实验详情</span>
		</div>
		<div class="course_tabInfoText clearfix">
			<img src="@/images/lab_tabInfoText.png" />
			<div class="course_tabInfoMain">
				{{labInfo.introduction || '暂无'}}
			</div>
		</div>
		<div class="lab_bottomTitle">
			<img src="@/images/lab_titleBack.png" class="lab_titleBack" />
			<span>实验步骤</span>
		</div>
		<div class="course_tabInfoText clearfix">
			<img src="@/images/lab_tabInfoText.png" />
			<div class="course_tabInfoMain">
				{{labInfo.info || '暂无'}}
			</div>
		</div>
		<div class="lab_bottomTitle">
			<img src="@/images/lab_titleBack.png" class="lab_titleBack" />
			<span>实验介绍</span>
		</div>
		<div class="course_tabInfoText clearfix">
			<img src="@/images/lab_scoreBack.png" />
			<div class="course_tabInfoMain course_tabInfoMainHeigh">
			<img src="@/images/info_icon.png" />
				{{labInfo.scoreEvaluate || '暂无'}}
			</div>
			{{labInfo.scoreEvaluate || '暂无'}}
		</div>-->
		<div class="lab_bottomTitle">
			<img src="@/images/lab_titleBack.png" class="lab_titleBack" />
			<span>实验介绍</span>
		</div>
		<div class="course_tabInfoText clearfix">
			<div class="course_tabInfonew" v-html='labInfo.scoreEvaluate'></div>
		</div>
	</div>
</template>

<script>
	import { getResourceDetail } from '@/api/simulation.js'
	export default {
		props: {
			vrDetailId: String,
			resourceId: String,
		},
		data() {
			return {
				labInfo: {},
			}
		},
		created() {
			this.getResourceDetail();
		},
		mounted() {

		},
		methods: {
			getResourceDetail() {
				getResourceDetail({
					vrDetailId: this.vrDetailId,
					resourceId: this.resourceId,
				}).then(res => {
					this.labInfo = res.data
				})
			},
		},
	}
</script>